function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.3335 4.00065C1.3335 3.63246 1.63197 3.33398 2.00016 3.33398H14.0002C14.3684 3.33398 14.6668 3.63246 14.6668 4.00065C14.6668 4.36884 14.3684 4.66732 14.0002 4.66732H2.00016C1.63197 4.66732 1.3335 4.36884 1.3335 4.00065Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.6665 1.99935C6.48969 1.99935 6.32012 2.06959 6.1951 2.19461C6.07007 2.31964 5.99984 2.4892 5.99984 2.66602V3.33268H9.99984V2.66602C9.99984 2.4892 9.9296 2.31964 9.80457 2.19461C9.67955 2.06959 9.50998 1.99935 9.33317 1.99935H6.6665ZM11.3332 3.33268V2.66602C11.3332 2.13558 11.1225 1.62687 10.7474 1.2518C10.3723 0.876729 9.8636 0.666016 9.33317 0.666016H6.6665C6.13607 0.666016 5.62736 0.876729 5.25229 1.2518C4.87722 1.62687 4.6665 2.13558 4.6665 2.66602V3.33268H3.33317C2.96498 3.33268 2.6665 3.63116 2.6665 3.99935V13.3327C2.6665 13.8631 2.87722 14.3718 3.25229 14.7469C3.62736 15.122 4.13607 15.3327 4.6665 15.3327H11.3332C11.8636 15.3327 12.3723 15.122 12.7474 14.7469C13.1225 14.3718 13.3332 13.8631 13.3332 13.3327V3.99935C13.3332 3.63116 13.0347 3.33268 12.6665 3.33268H11.3332ZM3.99984 4.66602V13.3327C3.99984 13.5095 4.07007 13.6791 4.1951 13.8041C4.32012 13.9291 4.48969 13.9993 4.6665 13.9993H11.3332C11.51 13.9993 11.6795 13.9291 11.8046 13.8041C11.9296 13.6791 11.9998 13.5095 11.9998 13.3327V4.66602H3.99984Z"
});

var SvgTrashcan = function SvgTrashcan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#6D7F92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashcan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashcan.f22d53f8.svg";
export { ForwardRef as ReactComponent };